import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { AppCard, AppRemixIcon } from '@/layout/AppComponents';
import styled from 'styled-components';
import { UnmountClosed } from 'react-collapse';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../../components/helpers/Translator';
import colors from '../../../../../../constants/colors';
import {
  getInherentImpact,
  getPriority,
  getProbability,
  getRiskState,
  getRiskType,
  getSeverity,
} from '../../tools/totalEnergiesRiskRiskTools';
import TotalEnergiesRiskRiskExpandedContainer from './TotalEnergiesRiskRiskExpandedContainer';

export default function RiskDefault({ elementID }) {
  const riskLevel1 = useSelector(
    (state) => state.currentPage?.elementLevels?.level1?.[elementID]
  );
  const [isOpened, setIsOpened] = useState(false);

  if (!riskLevel1) {
    return (
      <LoaderContainer key={elementID} className="mb-1">
        <div className="card default">
          <div className="card-body" />
        </div>
      </LoaderContainer>
    );
  }

  return (
    <Container
      key={elementID}
      $bgColor={
        riskLevel1?.active
          ? colors?.totalEnergiesRiskRiskState[riskLevel1?.state]
          : colors?.danger
      }
      className="mb-1"
    >
      <AppCard bodyClassName="p-0 default" headerClassName="p-0">
        <div className="default-content">
          <div className="content">
            <div
              className="state"
              title={
                riskLevel1?.active
                  ? getRiskState(riskLevel1?.state)
                  : 'Desactivado'
              }
            >
              {!riskLevel1?.active && (
                <AppRemixIcon icon="delete-bin" color="#fff" size={20} />
              )}
            </div>
            <div className="content-col">
              <div className="text-primary header container-header mb-2">
                {getRiskState(riskLevel1?.state)}
                <div>{riskLevel1?.code}</div>
              </div>
              <div className="text-primary header container-header">
                Tipo de riesgo:
              </div>
              <div>{getRiskType(riskLevel1?.riskType)}</div>
              <div className="text-primary header container-header">
                Descripción:
              </div>
              <div>{riskLevel1?.description}</div>
            </div>
            <div className="content-col">
              <div className="text-primary header container-header">
                Causas:
              </div>
              <div>{`${riskLevel1?.causes || '-'} \n\n`}</div>
              <div className="text-primary header">Consecuencias</div>
              {`${riskLevel1?.consequences || '-'} \n\n`}
            </div>
            <div className="content-col">
              <div className="text-primary header container-header">
                Probabilidad:
              </div>
              <div>{getProbability(riskLevel1?.probability)}</div>
              <div className="text-primary header">Impacto inherente</div>
              <div>{getInherentImpact(riskLevel1?.inherentImpact)}</div>
            </div>
            <div className="content-col">
              <div className="text-primary header container-header">
                Existen controles:
              </div>
              <div>{riskLevel1?.hasControls ? 'Sí' : 'No'}</div>
              <div className="text-primary header">Severidad:</div>
              <div>{getSeverity(riskLevel1?.severity)}</div>
              <div className="text-primary header">Prioridad:</div>
              <div>{getPriority(riskLevel1?.priority)}</div>
            </div>
          </div>
          <div
            className="expand pointer"
            onClick={() => setIsOpened(!isOpened)}
          >
            <AppRemixIcon icon={isOpened ? 'subtract' : 'add'} color="white" />
          </div>
        </div>
      </AppCard>
      <UnmountClosed isOpened={isOpened}>
        <TotalEnergiesRiskRiskExpandedContainer elementID={elementID} />
      </UnmountClosed>
    </Container>
  );
}

const LoaderContainer = styled.div`
  & > .card {
    height: 126px;
  }
`;

const Container = styled.div`
  & > .card {
    height: 126px;
    border-radius: 5px;
    border: 1px solid;
  }

  .default-content {
    display: grid;
    grid-template-columns: 1fr 40px;

    .content {
      display: grid;
      grid-template-columns: 40px 1fr 1fr 1fr 1fr;

      .state {
        background-color: ${(props) => props?.$bgColor};
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .content-col {
        border-right: 1px solid #ccc;
        padding: 6px;
        overflow-y: auto;
        height: 124px;
        font-size: 12px;

        .container-header {
          display: flex;
          flex: auto;
          justify-content: space-between;
        }

        hr {
          margin-top: 0.25rem;
          margin-bottom: 0.25rem;
        }

        .header {
          font-weight: bold;
          /* text-primary */
        }

        .agent-row {
          display: flex;
          flex-direction: row;
        }

        .container-other-agents {
          display: flex;
          justify-content: space-between;
        }

        .third-col {
          display: flex;
          justify-content: space-around;
          align-content: center;

          .column {
            display: flex;
            flex-direction: column;
            align-items: center;

            .header {
              font-weight: bold;
              /* text-primary */
            }

            .description {
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;
            }
          }
        }

        .fourth-col {
          display: flex;
          justify-content: space-between;

          .header {
            font-weight: bold;
            /* text-primary */
          }

          .first-col {
            display: flex;
            flex-direction: column;
            align-items: center;
            align-self: center;
          }

          .second-col {
            text-align: end;
            align-self: center;
          }
        }
      }
    }
    & > .expand {
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border-radius: 2px;
      font-size: 20px;
      height: 120px;
      margin: 2px;
      background-color: ${colors.primary};
    }
  }
`;
